export enum CartTabType {
  ENP = 'enp',
  LKP = 'lkp'
}
